export default "__VITE_ASSET__DZy9q0lR__"